module.exports = __webpack_public_path__ + "static/05-7632c9e2c90b815ac4e3ef79c17ae054.jpg";